module.exports = __webpack_public_path__ + "img/icon_screw.bdcabb61.svg";